<div class="flex flex-column gap-2">
  <div class="basis-1/2">
    <nx-table-header class="text-[1rem]" [label]="'Vorgangstypen'">
      <ng-template nxTemplate="end">
        <!-- <nx-command-button
          [reloadable]="reloadable"
          [style]="'light'"
          [commandName]="'issueTypeCreateCommand'"
          [icon]="'icon-plus'">
        </nx-command-button> -->
      </ng-template>
    </nx-table-header>
    <p-table #issueTypesTable [lazy]="true" (onLazyLoad)="loadData($event)" [value]="dataSource?.data" [scrollable]="true"
      [paginator]="true" [rows]="15" selectionMode="single" 
      [(selection)]=dataSource.selectedIssueType
      dataKey="code" 
      (onRowSelect)="setMenuItems()"
      [rowsPerPageOptions]="[15, 20, 50]" [totalRecords]="dataSource?.totalElements"
      [sortField]="sortProperty" [sortOrder]="translateSortDirectionToSortOrder(sortDirection)"
      [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} von {totalRecords}"
      [resizableColumns]="true">
      <ng-template pTemplate="caption">
        <div class="flex flex-row">
          <div class="basis-2/3 flex flex-row gap-2">
            <!-- no filter -->
          </div>
          <div class="basis-1/3 flex flex-row justify-end">
            <!-- <p-dropdown placeholder="Sortierung" [styleClass]="'sort'" appendTo="body" [ngModel]="sortModel"
              [options]="sortOptions | translateLabels" optionLabel="label" [showClear]="false" (onChange)="sort($event)">
            </p-dropdown> -->
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="min-width: 3rem; width: 3rem;">Icon</th>
          <th style="min-width: 5rem; width: 8rem;">Name</th>
          <th style="min-width: 3rem; width: 3rem;">Aktiv</th>
          <th style="min-width: 3rem; width: 3rem;">System</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-issueType>
        <tr class="clickable" [pSelectableRow]="issueType">
          <td>
            <i class="relative top-[-1px] left-[-2px] text-[30px]" [ngClass]="issueType.icon"></i>
          </td>
          <td>
            {{issueType.name}}
          </td>
          <td>
            <input type="checkbox" [checked]="issueType?.isActive" disabled />
          </td>
          <td> 
            <input type="checkbox" [checked]="issueType?.isSystem" disabled />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="emptyMessage">Keine Status Typen gefunden.</td>
        </tr>
      </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
    </ng-template>
  </div>
  <div class="basis-1/2">
    <nx-headline-box
      [label]="'Einstellungen'">
      <ng-template nxTemplate="end">
        <!-- <nx-default-button
          [menuItems]="menuItems"
          [menuWithIcon]="false"
          class="pt-1"
          [icon]="'icon-options'">
        </nx-default-button> -->
      </ng-template>
    </nx-headline-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Name'">
      {{dataSource?.selectedIssueType?.name}}
      <!-- <ng-template
        nxTemplate="end">
      </ng-template> -->
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Prefix'">
      {{dataSource?.selectedIssueType?.prefix}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Farbe'">
      <span 
        class="inline-block w-3 h-3 rounded-sm align-middle mr-1 border border-gray-300"
        [ngStyle]="{ 'background-color': dataSource?.selectedIssueType?.color }">
      </span>
      {{dataSource?.selectedIssueType?.color}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Prefix'">
      {{dataSource?.selectedIssueType?.prefix}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Icon'">
      <i class="relative top-[-1px] left-[-2px] text-[30px]" [ngClass]="dataSource?.selectedIssueType?.icon"></i>
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'System'">
      <input type="checkbox" [checked]="dataSource?.selectedIssueType?.isActive" disabled />
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Aktiv'">
      <input type="checkbox" [checked]="dataSource?.selectedIssueType?.isSystem" disabled />
    </nx-default-box>
    <!-- <nx-default-box class="bg-white border-b border-gray"
      [label]="'coreModuleModule.subscriptionsComponent.details.headlines.externalId' | translate">
      {{dataSource?.selectedEventSubscription?.externalId}}
      <ng-template
        nxTemplate="end">
        <nx-default-button
          [disabled]="!this.dataSource?.selectedEventSubscription?.externalId"
          (click)="copyToClipboard(dataSource?.selectedEventSubscription?.externalId)"
          [style]="'light'"
          [icon]="'icon-copy'"
          [tooltip]="'coreModuleModule.subscriptionsComponent.details.copyToolTip' | translate">
        </nx-default-button>
      </ng-template>
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Status'">
  <ng-container *ngIf="dataSource?.selectedEventSubscription; else noSubscriptionSelected">
    {{dataSource?.selectedEventSubscription?.active ? ('coreModuleModule.subscriptionsComponent.subscriptionIsActive' | translate) : ('coreModuleModule.subscriptionsComponent.subscriptionIsNotActive' | translate)}}
  </ng-container>
  <ng-template #noSubscriptionSelected>
    -
  </ng-template>
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModuleModule.subscriptionsComponent.details.headlines.url' | translate">
      {{dataSource?.selectedEventSubscription?.url}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModuleModule.subscriptionsComponent.details.headlines.eventTypes' | translate">
      {{dataSource?.selectedEventSubscription?.eventTypes?.length > 0 ? dataSource?.selectedEventSubscription?.eventTypes.join(', ') : '-'}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModuleModule.subscriptionsComponent.details.headlines.lastTriggeredDateTime' | translate">
      {{dataSource?.selectedEventSubscription?.lastTriggeredDateTime ? (dataSource?.selectedEventSubscription?.lastTriggeredDateTime | date:'dd.MM.YY HH:mm:ss') : '-'}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModuleModule.subscriptionsComponent.details.headlines.customHeaders' | translate">
      <div *ngIf="dataSource?.selectedEventSubscription?.customHeadersArray?.length > 0; else noCustomHeaders">
        <ul class="list-disc pl-5">
          <li *ngFor="let header of dataSource?.selectedEventSubscription?.customHeadersArray">
            {{header?.name}}: {{header?.value}}
          </li>
        </ul>
      </div>
      <ng-template #noCustomHeaders>
        -
      </ng-template>
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModuleModule.subscriptionsComponent.details.headlines.secret' | translate">
      {{ dataSource?.selectedEventSubscription?.secretHash ? '••••••••••••••••' : '-' }}
    </nx-default-box> -->

  </div>
</div>